/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Action_WeightInputs */

const en_us2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens your profile at Body, straight to logging your weight.`)
};

const pt_br2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre o seu perfil em Corpo, direto no registro de peso.`)
};

const es_419_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre tu perfil en Cuerpo, directo en el registro de peso.`)
};

const pt_pt2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre o teu perfil em Corpo, diretamente no registo de peso.`)
};

const fr_fr2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvre ton profil à Corps, directement sur l'enregistrement du poids.`)
};

const de_de2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnet dein Profil bei Körper, direkt zum Eintragen deines Gewichts.`)
};

const it_it2_search_preview_action_weight = /** @type {(inputs: Search_Preview_Action_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apre il tuo profilo su Corpo, direttamente alla registrazione del peso.`)
};

/**
* | output |
* | --- |
* | "Opens your profile at Body, straight to logging your weight." |
*
* @param {Search_Preview_Action_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_action_weight = /** @type {((inputs?: Search_Preview_Action_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Action_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_action_weight(inputs)
	if (locale === "es-419") return es_419_search_preview_action_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_action_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_action_weight(inputs)
	if (locale === "de-DE") return de_de2_search_preview_action_weight(inputs)
	if (locale === "it-IT") return it_it2_search_preview_action_weight(inputs)
	return en_us2_search_preview_action_weight(inputs)
});
export { search_preview_action_weight as "search.preview_action_weight" }